import $http from '@vue-util/http';
import { errorHandler } from '@/utils/ErrorHandler';
import { PROTECTION_PLAN_DETAILS_ENDPOINT } from '#shared/endpoints';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';
import { PROTECTION_PLAN_SLIDEOUT } from 'config';

export const useProtectionPlanStore = defineStore('protectionPlanStore', {
  state: () => ({
    slideout: {
      id: '',
      title: '',
      props: {},
      footer: {},
      component: null,
    },
    protectionPlanDetails: null,
    isLoading: false,
    error: '',
  }),

  getters: {
    coverageStatus: (state) => state.protectionPlanDetails?.coverageStatus ?? null,
  },

  actions: {
    SET_SLIDEOUT(slideout) {
      this.slideout = slideout;
    },
    SET_PROTECTION_PLAN_DATA(data, isLoading = false) {
      this.protectionPlanDetails = data;
      this.isLoading = isLoading;
      this.error = '';
    },
    RESET_PROTECTION_PLAN_DETAILS() {
      this.protectionPlanDetails = null;
      this.error = '';
    },
    SET_ERROR(message) {
      this.error = message;
    },
    async GET_PROTECTION_PLAN_DETAILS({ orderNumber = '', serviceLineId = '' } = {}) {
      const envPropsStore = useEnvPropsStore();
      const headers = {
        'X-Macys-ClientId': 'SITE',
        'X-Macys-DeviceId': envPropsStore.deviceType,
      };

      this.RESET_PROTECTION_PLAN_DETAILS();
      this.isLoading = true;

      try {
        const response = await $http.post(PROTECTION_PLAN_DETAILS_ENDPOINT, { orderNumber, serviceLineId }, { headers });

        if (!response.data?.coverageStatus) {
          throw new Error();
        }

        this.SET_PROTECTION_PLAN_DATA(response.data);
      } catch (error) {
        const message = errorHandler(error, PROTECTION_PLAN_SLIDEOUT.error_message);
        this.SET_ERROR(message);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
